/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'report': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M3.25 3c0-.966.784-1.75 1.75-1.75h14c.966 0 1.75.784 1.75 1.75v18A1.75 1.75 0 0119 22.75H5A1.75 1.75 0 013.25 21v-4.014h-.5a.75.75 0 010-1.5h.5V8.75h-.5a.75.75 0 010-1.5h.5V3zm1.5 12.486V8.75h.062a.75.75 0 000-1.5H4.75V3A.25.25 0 015 2.75h14a.25.25 0 01.25.25v18a.25.25 0 01-.25.25H5a.25.25 0 01-.25-.25v-4.014h.062a.75.75 0 000-1.5H4.75zm2.406-5.5a.75.75 0 01.75-.75h8.248a.75.75 0 010 1.5H7.906a.75.75 0 01-.75-.75zm.75 2.338a.75.75 0 000 1.5h8.248a.75.75 0 100-1.5H7.906z" _fill="#000"/>'
  }
})
